{
  "nl": {
    "survey_type": {
      "actions": {
        "changeResponsible": "Verander verantwoordelijke"
      },
      "attributes": {
        "introduction": "Beschrijving",
        "responsible": "Verantwoordelijke",
        "title": "Titel"
      },
      "labels": {
        "ask_question": "Wat voor vraag wil je stellen?",
        "editInternalTitle": "De interne titel bijwerken?",
        "explainerNPSPart1": "De Net Promoter Score is een index van -100 tot 100 die de bereidheid van klanten meet om jouw organisatie of projecten aan anderen aan te bevelen.",
        "explainerOpinionScale": "Meet de mening van je klanten met een eigen gekozen vraag.",
        "fixed_choice": "Meerkeuzevraag",
        "hidePreview": "Preview verbergen",
        "moreInfo": "Meer informatie",
        "nps": "Net Promoter Score",
        "npsQuestion": "NPS",
        "open_ended": "Open vraag",
        "opinion_scale": "Opinieschaal",
        "preview": "Preview",
        "satisfaction": "Tevredenheid",
        "selectSurveyType": "Selecteer enquête",
        "showPreview": "Preview tonen",
        "tab_summary": "Overzicht",
        "tab_units": "Units",
        "yes_no": "Ja-Nee"
      },
      "navigation": {
        "backToSurveyTypes": "Terug naar enquêtes"
      },
      "snackbars": {
        "duplicate": "De enquête is gemaakt, maar het kopiëren vanuit de sjabloon kan een paar minuten duren."
      },
      "toasts": {
        "bulk_delete": "Enquête succesvol verwijderd | Enquêtes succesvol verwijderd",
        "update": "Enquête succesvol bijgewerkt"
      },
      "validation": {
        "nameAlreadyTaken": "Naam is al bezet voor dit project",
        "need_name": "Titel vereist",
        "selectSurveyType": "Selecteer ten minste 1 enquête"
      }
    }
  }
}
